<template>
    <div class="mt-3">
        <UserPasswordInput :password.sync="password" />
        <v-button prevent-default
                  aria-hidden="true"
                  tabindex="2"
                  @click="updateUserPassword"
        >
            <fa-icon :icon="['fas', 'user-lock']" /> Update Password
        </v-button>
    </div>
</template>

<script>
import alertManager from '~/plugins/alertManager';
import UserPasswordInput from './UserPasswordInput';

export default {
    components: { UserPasswordInput },
    props: {
        userId: { type: Number, required: true },
    },

    data() {
        return {
            password: null,
        };
    },

    methods: {
        updateUserPassword() {
            this.$store
                .dispatch('auth/updateUserPassword', {
                    user_id: this.userId,
                    password: this.password,
                })
                .then(() => {
                    alertManager.showSuccess({
                        message: 'Password was successfully updated.',
                    });
                });
        },
    },
};
</script>
